import { PlanSelection } from "@/modules/plan-selection/views/plan-selection-view";
import { useCheckoutRedirectHandler } from "@/modules/checkout-session";

export function PlanSelectionPage() {
  const { handleCheckoutFetched } = useCheckoutRedirectHandler();

  return <PlanSelection onCheckoutFetched={handleCheckoutFetched} />;
}
